var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"print-part-images"}},[_c('div',{staticClass:"container"},_vm._l((_vm.partImageUrls),function(imageUrl,index){return _c('div',{key:index},[_c('img',{attrs:{"src":imageUrl},on:{"load":function($event){_vm.loadedImageCount += 1}}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }